"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const to_top = document.getElementById("to-top");
if (to_top) {
    to_top.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
}
(0, jquery_1.default)(".menu-toggle").on("click", function () {
    (0, jquery_1.default)("#menu").fadeToggle(300);
    return false;
});
(0, jquery_1.default)(".searchMenu-toggle").on("click", function () {
    (0, jquery_1.default)("#searchMenu").fadeToggle(300);
    return false;
});
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const href = e.currentTarget.getAttribute("href");
        if (href) {
            const targetElement = document.querySelector(href);
            if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - 80;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    });
});
(0, jquery_1.default)(".point-toggle").on("click", function () {
    (0, jquery_1.default)("#point").fadeToggle(100);
    return false;
});
(0, jquery_1.default)(".mypageMain__tab li").on("click", function () {
    const index = (0, jquery_1.default)(this).index();
    (0, jquery_1.default)(".mypageMain__tab li").removeClass("active");
    (0, jquery_1.default)(this).addClass("active");
    (0, jquery_1.default)(".mypageMain__group").eq(index).addClass("active");
    (0, jquery_1.default)(".mypageMain__group").eq(index).siblings().removeClass("active");
    const $delete = (0, jquery_1.default)("#content-delete");
    if (index === 0) {
        $delete.css("display", "block");
    }
    else {
        $delete.css("display", "none");
    }
    return false;
});
document.addEventListener("DOMContentLoaded", () => {
    const buy_post_form = document.getElementById("buy-post-form");
    const delete_premium_form = document.getElementById("delete-premium-form");
    const delete_member_form = document.getElementById("delete-member-form");
    if (buy_post_form) {
        buy_post_form.addEventListener("submit", (e) => {
            e.preventDefault();
            if (confirm("ポイントを使用して購入しますか？")) {
                buy_post_form.submit();
            }
        });
    }
    if (delete_premium_form) {
        delete_premium_form.addEventListener("submit", (e) => {
            e.preventDefault();
            if (confirm("プレミアム会員を解約しますか？")) {
                delete_premium_form.submit();
            }
        });
    }
    if (delete_member_form) {
        delete_member_form.addEventListener("submit", (e) => {
            e.preventDefault();
            if (confirm("退会しますか？プレミアム会員の場合は自動的に解約されます。")) {
                delete_member_form.submit();
            }
        });
    }
    const raceSearchForm = document.getElementById("race-search");
    const dateInput = document.getElementById("race-date");
    if (raceSearchForm && dateInput) {
        raceSearchForm.addEventListener("submit", function (event) {
            event.preventDefault(); // デフォルトのフォーム送信を防止
            if (dateInput.value === "") {
                alert("日付を入力してください");
                return;
            }
            const date = new Date(dateInput.value);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            // @ts-ignore
            const race_url = `${ajax_login_object.homeurl}/race/${year}${month}${day}/`;
            console.log(race_url);
            // 遷移を実行
            window.location.href = race_url;
        });
    }
});
